import { useApiOrganisationAdminList } from 'state/__generated__/tadaahAPI';
import type { OrganisationAdminDetails } from 'state/__generated__/tadaahAPI';

type OrganizationAdminDetailsResponse = {
  data: OrganisationAdminDetails[] | undefined;
  isLoading?: boolean;
  error: Error | null;
};

const useGetOrganizationAdminDetails = (): OrganizationAdminDetailsResponse => {
  const { data, isLoading, error } = useApiOrganisationAdminList({
    query: {
      queryKey: ['organisation-admin-details'],
    },
  });

  return { data: data?.data, error, isLoading };
};

export default useGetOrganizationAdminDetails;
